var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,2C7.732,2,4.261,5.472,4.261,9.739c0,2.446,1.176,4.775,3.146,6.229l0.086,0.055c0.004,0.002,0.35,0.218,0.641,0.612 l0.124,3.024C8.311,20.95,9.405,22,10.697,22h2.614c1.284,0,2.393-1.043,2.472-2.324l0.193-3.122 c0.254-0.326,0.514-0.508,0.531-0.52c2.024-1.452,3.233-3.805,3.233-6.294C19.739,5.472,16.268,2,12,2z M9.697,18.145l-0.034-0.838 h4.763l-0.052,0.838H9.697z M13.311,20.5h-2.614c-0.472,0-0.882-0.388-0.929-0.855h4.5C14.205,20.112,13.786,20.5,13.311,20.5z  M15.653,14.799c-0.063,0.043-0.556,0.381-0.992,1.008H9.397c-0.432-0.618-0.956-0.963-1.133-1.069 c-1.569-1.174-2.504-3.039-2.504-4.998C5.761,6.299,8.56,3.5,12,3.5s6.239,2.799,6.239,6.239 C18.239,11.746,17.265,13.643,15.653,14.799z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.7395434bf296b6a46adb259b92b545fa.svg";
export { ForwardRef as ReactComponent };